import { BiteLogAdyenEvent, BiteLogAdyenEventHelper, BiteLogCardConnectEvent, BiteLogCardConnectEventHelper, BiteLogChaseEvent, BiteLogChaseEventHelper, BiteLogDeviceEvent, BiteLogDeviceEventHelper, BiteLogEigenEvent, BiteLogEigenEventHelper, BiteLogElavonEvent, BiteLogElavonEventHelper, BiteLogExpoPrinterEvent, BiteLogExpoPrinterEventHelper, BiteLogFatalError, BiteLogFatalErrorHelper, BiteLogFlashEvent, BiteLogFlashEventHelper, BiteLogFreedomPayEvent, BiteLogFreedomPayEventHelper, BiteLogGloryEvent, BiteLogGloryEventHelper, BiteLogHeartlandEvent, BiteLogHeartlandEventHelper, BiteLogKioskEvent, BiteLogKioskEventHelper, BiteLogLoyaltyEvent, BiteLogLoyaltyEventHelper, BiteLogLrsTableTrackerEvent, BiteLogLrsTableTrackerEventHelper, BiteLogMaitredEvent, BiteLogMaitredEventHelper, BiteLogMonerisEvent, BiteLogMonerisEventHelper, BiteLogOloPayKioskEvent, BiteLogOloPayKioskEventHelper, BiteLogParPayEvent, BiteLogParPayEventHelper, BiteLogPrinterEvent, BiteLogPrinterEventHelper, BiteLogPusherEvent, BiteLogPusherEventHelper, BiteLogSimpleEvent, BiteLogSimpleEventHelper, BiteLogSquareEvent, BiteLogSquareEventHelper, BiteLogStripeEvent, BiteLogStripeEventHelper, BiteLogTransactCampusCardEvent, BiteLogTransactCampusCardEventHelper, BiteLogType, BiteLogVerifoneCommanderEvent, BiteLogVerifoneCommanderEventHelper, BiteLogVerifonePointCloudEvent, BiteLogVerifonePointCloudEventHelper, BiteLogVerifonePointScaEvent, BiteLogVerifonePointScaEventHelper, BiteLogWorldpayEvent, BiteLogWorldpayEventHelper, } from '@biteinc/enums';
const LOG_HELPER_MAP = {
    [BiteLogType.Adyen]: {
        logStatusEnum: BiteLogAdyenEvent,
        logStatusEnumHelper: BiteLogAdyenEventHelper,
    },
    [BiteLogType.CardConnect]: {
        logStatusEnum: BiteLogCardConnectEvent,
        logStatusEnumHelper: BiteLogCardConnectEventHelper,
    },
    [BiteLogType.Chase]: {
        logStatusEnum: BiteLogChaseEvent,
        logStatusEnumHelper: BiteLogChaseEventHelper,
    },
    [BiteLogType.Device]: {
        logStatusEnum: BiteLogDeviceEvent,
        logStatusEnumHelper: BiteLogDeviceEventHelper,
    },
    [BiteLogType.Eigen]: {
        logStatusEnum: BiteLogEigenEvent,
        logStatusEnumHelper: BiteLogEigenEventHelper,
    },
    [BiteLogType.Elavon]: {
        logStatusEnum: BiteLogElavonEvent,
        logStatusEnumHelper: BiteLogElavonEventHelper,
    },
    [BiteLogType.FatalError]: {
        logStatusEnum: BiteLogFatalError,
        logStatusEnumHelper: BiteLogFatalErrorHelper,
    },
    [BiteLogType.Flash]: {
        logStatusEnum: BiteLogFlashEvent,
        logStatusEnumHelper: BiteLogFlashEventHelper,
    },
    [BiteLogType.FreedomPay]: {
        logStatusEnum: BiteLogFreedomPayEvent,
        logStatusEnumHelper: BiteLogFreedomPayEventHelper,
    },
    [BiteLogType.ExpoPrinter]: {
        logStatusEnum: BiteLogExpoPrinterEvent,
        logStatusEnumHelper: BiteLogExpoPrinterEventHelper,
    },
    [BiteLogType.Glory]: {
        logStatusEnum: BiteLogGloryEvent,
        logStatusEnumHelper: BiteLogGloryEventHelper,
    },
    [BiteLogType.Heartland]: {
        logStatusEnum: BiteLogHeartlandEvent,
        logStatusEnumHelper: BiteLogHeartlandEventHelper,
    },
    [BiteLogType.JTechTableTracker]: {
        logStatusEnum: BiteLogLrsTableTrackerEvent,
        logStatusEnumHelper: BiteLogLrsTableTrackerEventHelper,
    },
    [BiteLogType.Kiosk]: {
        logStatusEnum: BiteLogKioskEvent,
        logStatusEnumHelper: BiteLogKioskEventHelper,
    },
    [BiteLogType.Loyalty]: {
        logStatusEnum: BiteLogLoyaltyEvent,
        logStatusEnumHelper: BiteLogLoyaltyEventHelper,
    },
    [BiteLogType.LrsTableTracker]: {
        logStatusEnum: BiteLogLrsTableTrackerEvent,
        logStatusEnumHelper: BiteLogLrsTableTrackerEventHelper,
    },
    [BiteLogType.Maitred]: {
        logStatusEnum: BiteLogMaitredEvent,
        logStatusEnumHelper: BiteLogMaitredEventHelper,
    },
    [BiteLogType.Moneris]: {
        logStatusEnum: BiteLogMonerisEvent,
        logStatusEnumHelper: BiteLogMonerisEventHelper,
    },
    [BiteLogType.OloPayKiosk]: {
        logStatusEnum: BiteLogOloPayKioskEvent,
        logStatusEnumHelper: BiteLogOloPayKioskEventHelper,
    },
    [BiteLogType.ParPay]: {
        logStatusEnum: BiteLogParPayEvent,
        logStatusEnumHelper: BiteLogParPayEventHelper,
    },
    [BiteLogType.Printer]: {
        logStatusEnum: BiteLogPrinterEvent,
        logStatusEnumHelper: BiteLogPrinterEventHelper,
    },
    [BiteLogType.Pusher]: {
        logStatusEnum: BiteLogPusherEvent,
        logStatusEnumHelper: BiteLogPusherEventHelper,
    },
    [BiteLogType.Simple]: {
        logStatusEnum: BiteLogSimpleEvent,
        logStatusEnumHelper: BiteLogSimpleEventHelper,
    },
    [BiteLogType.Square]: {
        logStatusEnum: BiteLogSquareEvent,
        logStatusEnumHelper: BiteLogSquareEventHelper,
    },
    [BiteLogType.Stripe]: {
        logStatusEnum: BiteLogStripeEvent,
        logStatusEnumHelper: BiteLogStripeEventHelper,
    },
    [BiteLogType.TransactCampusCard]: {
        logStatusEnum: BiteLogTransactCampusCardEvent,
        logStatusEnumHelper: BiteLogTransactCampusCardEventHelper,
    },
    [BiteLogType.VerifoneCommander]: {
        logStatusEnum: BiteLogVerifoneCommanderEvent,
        logStatusEnumHelper: BiteLogVerifoneCommanderEventHelper,
    },
    [BiteLogType.VerifonePointCloud]: {
        logStatusEnum: BiteLogVerifonePointCloudEvent,
        logStatusEnumHelper: BiteLogVerifonePointCloudEventHelper,
    },
    [BiteLogType.VerifonePointSca]: {
        logStatusEnum: BiteLogVerifonePointScaEvent,
        logStatusEnumHelper: BiteLogVerifonePointScaEventHelper,
    },
    [BiteLogType.Worldpay]: {
        logStatusEnum: BiteLogWorldpayEvent,
        logStatusEnumHelper: BiteLogWorldpayEventHelper,
    },
};
export function getLogStatusEnumAndHelperForLogType(logType) {
    return LOG_HELPER_MAP[logType];
}
//# sourceMappingURL=log_helper.js.map